import { ButtonUiState } from '@/components/Common/Button/ButtonUi';
import { statusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';

export type SellerProfileUi = {
  sellerId?: string;
  title: string;
  status?: statusBadgeUi;
  moreActions?: ButtonUiState[];
  isActive?: boolean;
};

export const initialState: SellerProfileUi = {
  title: '',
  moreActions: [],
};
